/**
 * Обучение перед первым показом экрана — один раз на пользователя (в этом браузере): после «Показать экран»,
 * «Не сейчас», крестика или Escape пункт меню начинает показ сразу. Версия в ключе — чтобы заметную переработку показа
 * объяснить заново.
 */
const storageKey = (userId: number | string) => `srm.screenShare.introSeen:v1:${userId}`;

export function isSupportShareIntroSeen(userId: number | string): boolean {
    try {
        return localStorage.getItem(storageKey(userId)) === '1';
    } catch {
        // localStorage недоступен — не показываем обучение перед каждым показом.
        return true;
    }
}

export function markSupportShareIntroSeen(userId: number | string): void {
    try {
        localStorage.setItem(storageKey(userId), '1');
    } catch {
        /* localStorage недоступен — просто не сохраняем */
    }
}
